import { createSelector, createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { generateSearchParams } from 'utils/helpers/fetch';

const initialState = {
  error: '',
  locationsList: [],
  pending: false,
};

const reducers = {
  fetchLocationsError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchLocationsPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchLocationsSuccess(state, { payload }) {
    return R.assoc('locationsList', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'locations',
  reducers,
});

const { fetchLocationsPending, fetchLocationsSuccess, fetchLocationsError } = actions;

// Selectors
const locationsListSelector = state => state.pto.locations.locationsList;

export const locationOptionsSelector = createSelector(locationsListSelector, locations =>
  locations.map(({ locationName: label, locationId }) => ({
    label,
    value: `${locationId}`,
  }))
);

// Actions
let fetchController;
export function fetchLocations() {
  return (dispatch, getState) => {
    const { currentAffiliate } = getState().pto.searchPtos;
    const formattedAffiliate = currentAffiliate
      ? {
          affiliate: {
            companyCustomerIdName: currentAffiliate.customerIdName,
            dataCompanyId: currentAffiliate.dataCompanyId,
          },
        }
      : null;
    const paramString = qs.stringify(
      generateSearchParams(getState().pto.searchPtoFilters, formattedAffiliate),
      { allowDots: true, encode: false }
    );
    dispatch(fetchLocationsPending(true));
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();
    const { signal } = fetchController;
    http
      .get(`/product-transfer-orders/get-unique-locations-list?${paramString}`, { signal })
      .then(res => {
        dispatch(fetchLocationsError(''));
        dispatch(fetchLocationsSuccess(res.data));
        dispatch(fetchLocationsPending(false));
      });
  };
}

export default reducer;
